import { useState } from "react";
import colorSharp from "../assets/img/skills-bg.png";
import { FaGraduationCap } from "react-icons/fa";
import aracomLogo from "../assets/img/aracom.jpg";
import evyLogo from "../assets/img/evy-logo.png";
import impulsLogo from "../assets/img/impuls-logo.png";

const steps = [
  {
    key: "discovery",
    label: "Ausbildung zum Softwareentwickler",
    icon: <FaGraduationCap size={40} />,
  },
  {
    key: "strategy",
    label: "Junior Softwareentwickler bei AraCom",
    icon: <img src={aracomLogo} alt="AraCom Logo" />,
  },
  {
    key: "creative",
    label: "Frontend Entwickler bei Evy Solutions GmbH",
    icon: <img src={evyLogo} alt="Evy Solutions Logo" />,
  },
  {
    key: "production",
    label: "Frontend Entwickler bei Impuls AG",
    icon: (
      <img src={impulsLogo} style={{ maxWidth: "80px" }} alt="Impuls AG Logo" />
    ),
  },
];

export const Timeline = () => {
  const [activeStep, setActiveStep] = useState(0);

  // 0% beim ersten, 100% beim letzten Schritt – Mindestwert, damit die
  // Leiste auch am Anfang sichtbar ist
  const progress =
    activeStep === 0 ? "4%" : `${(activeStep / (steps.length - 1)) * 100}%`;

  return (
    <section className="timeline" id="timeline">
      <div className="timeline-headline">
        <h2>Karriere Zeitstrahl</h2>
      </div>
      <div className="timeline-container">
        <div className="process-wrapper">
          <div className="progress-track">
            <div className="progress-line">
              <div
                className="progress-line-fill"
                style={{ "--progress": progress }}
              />
            </div>
            <div className="progress-steps">
              {steps.map((step, index) => (
                <button
                  key={step.key}
                  type="button"
                  className={`progress-step ${
                    index <= activeStep ? "active" : ""
                  }`}
                  onClick={() => setActiveStep(index)}
                  aria-current={index === activeStep}
                >
                  <span className="progress-step-icon">{step.icon}</span>
                  <span className="progress-step-label">{step.label}</span>
                </button>
              ))}
            </div>
          </div>

          <div id="progress-content-section">
            {activeStep === 0 && (
              <div className="section-content discovery">
                <h2>Ausbildung</h2>
                <h5>2019-2022</h5>
                <div className="timeline-lead">
                  Abgeschlossene Ausbildung zum Fachinformatiker für
                  Anwendungsentwicklung mit{" "}
                  <span style={{ color: "#2ab4cd" }}>
                    <b>89 von 100 Punkten</b>
                  </span>
                  <br />
                  <span style={{ color: "#2ab4cd" }}>
                    <b>Abschluss der Berufsschule mit einem Schnitt von: 1,2</b>
                  </span>
                </div>
                <h5>
                  <b>Abschlussprojekt Thema: </b>
                </h5>
                <span>
                  Webanwendung zur digitalen Erfassung, Verwaltung und
                  Übermittlung der Berichtshefte an die IHK für nachfolgende
                  Auszubildenden Jahrgänge <br />
                  Zweck: Ersatz der Papierberichtshefte, durch digitale Hefte
                  für die Industrie- und Handelskammer (IHK)
                </span>
                <br />
                <br />
                <span>
                  <b>Technologien:</b> C# ASP.Net Core, React.JS Ant-Design,
                  MongoDB
                </span>
                <div className="timeline-task-box">
                  <h5>Hauptaufgaben:</h5>
                  <div className="timeline-tasks">
                    <span>
                      <span className="progress-content-bulletpoint">• </span>
                      Implementierung/Erstellung von Stundenplänen, eines
                      Schulkalenders und bearbeitbaren Schulfächern
                    </span>
                    <span>
                      <span className="progress-content-bulletpoint">• </span>
                      Automatisierungsprozess für die Erstellung digitaler
                      Berichtshefte
                    </span>
                    <span>
                      <span className="progress-content-bulletpoint">• </span>
                      Erstellung eines Dashboards für Auszubildende
                    </span>
                  </div>
                </div>
              </div>
            )}

            {activeStep === 1 && (
              <div className="section-content strategy">
                <h2>
                  Ende der Ausbildung und Tätigkeit als
                  Junior-Softwareentwickler bei AraCom IT Services GmbH
                </h2>
                <h5>2022-2023</h5>
                <p className="timeline-lead">
                  Im zweiten Jahr Einsatz in Kundenprojekt in Bereich
                  Medienbranche bei „Sport1“ <br /> zur Unterstützung bei der
                  Entwicklung von der Website und der App
                </p>
                <span>
                  <b>Technologien:</b> React.JS, React Native, TypeScript
                </span>
                <div className="timeline-task-box">
                  <h5>Hauptaufgaben:</h5>
                  <div className="timeline-tasks">
                    <span>
                      <span className="progress-content-bulletpoint">• </span>
                      Implementierung neuer Funktionen in Web- und
                      Mobile-Anwendungen
                    </span>
                    <span>
                      <span className="progress-content-bulletpoint">• </span>
                      Verbesserung, Fehlerbehebung und Wartung bestehender
                      Komponenten
                    </span>
                    <span>
                      <span className="progress-content-bulletpoint">• </span>
                      Frontend Testing mit der <b>enzyme</b> library
                    </span>
                  </div>
                </div>
              </div>
            )}

            {activeStep === 2 && (
              <div className="section-content creative">
                <h2>Evy Solutions</h2>
                <h5>2023-2024</h5>
                <p className="timeline-lead">
                  Dokumenten- und E-Mail-Analyse mit künstlicher Intelligenz{" "}
                  <br />
                  KI-gestützte Software für die Dokumentenverarbeitung und
                  Prozessautomatisierung
                  <br />
                  <b>Technologien:</b> React.JS, TypeScript
                </p>
                <div className="timeline-task-box">
                  <h5>Hauptaufgaben:</h5>
                  <div className="timeline-tasks">
                    <span>
                      <span className="progress-content-bulletpoint">• </span>
                      Implementierung und Erstellung einer
                      B2B-Wirtschaftswebanwendung zur Verwaltung von
                      Geschäftsdaten, zur Erstellung von Produktanfragen für
                      Kunden und zur Erstellung von Workflows, um die Anfragen
                      an die entsprechenden Abteilungen zu senden.
                    </span>
                    <span>
                      <span className="progress-content-bulletpoint">• </span>
                      Arbeit am Frontend der Webanwendung des Hauptprodukts, die
                      KI-basierte Schulungen zu Dokumenten erstellt, um die
                      Erstellung von z. B. Rechnungen zu automatisieren
                    </span>
                    <span>
                      <span className="progress-content-bulletpoint">• </span>
                      UI/UX Design für neue Features
                    </span>
                    <span>
                      <span className="progress-content-bulletpoint">• </span>
                      Verbesserung und Wartung von bestehenden Anwendungen
                    </span>
                    <span>
                      <span className="progress-content-bulletpoint">• </span>
                      Frontend Testing mit <b>playwright</b> framework
                    </span>
                  </div>
                </div>
              </div>
            )}

            {activeStep === 3 && (
              <div className="section-content production">
                <h2>Impuls AG</h2>
                <h5>2024-bis heute</h5>
                <p className="timeline-lead">
                  Versicherungsmakler für private Kranken-, Sach-, Lebens- und
                  Kfz-Versicherungen
                  <br />
                  <b>Technologien:</b> ASP.Net Core, React.JS, JavaScript, Java
                </p>
                <div className="timeline-task-box">
                  <h5>Hauptaufgaben:</h5>
                  <div className="timeline-tasks">
                    <span>
                      <span className="progress-content-bulletpoint">• </span>
                      Wartung und Weiterentwicklung der zentralen Webanwendung
                      zur Verwaltung von Kunden und deren Versicherungspolicen
                    </span>
                    <span>
                      <span className="progress-content-bulletpoint">• </span>
                      Neugestaltung und Überarbeitung interner
                      Webanwendungen/Tools
                    </span>
                    <span>
                      <span className="progress-content-bulletpoint">• </span>
                      Erweiterung der Webseite mit neuen Modulen, Skripten und
                      Funktionen, die anhand von HubSpot, einer CRM-Plattform,
                      gehostet wird.
                    </span>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
      <img
        className="background-image"
        src={colorSharp}
        alt="spotlight-background"
      />
    </section>
  );
};
